/* eslint-disable no-case-declarations */
import _ from 'lodash';
import initialState from './initialState';
// eslint-disable-next-line import/no-cycle
import { types } from './actions';
import * as helper from '../lib/helper';

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setUserList(userList) {
  return { type: types.SET_USER_LIST, userList };
}

export function setGridParam(gridParam) {
  return { type: types.SET_GRID_PARAM, gridParam };
}

export function setIsExporting(isExporting) {
  return { type: types.SET_EXPORTING, isExporting };
}

function updatePickListsStateKey(state, key, isLoading, items) {
  return {
    ...state,
    [key]: {
      items,
      isLoading,
    },
  };
}

function deleteUser(itemList, userDelted) {
  const newUserList = [...itemList];
  newUserList.splice(
    newUserList.findIndex((x) => x.id === userDelted.id),
    1
  );
  return newUserList;
}

function addUser(itemList, userAdded, userToBeDeleted) {
  const newUserList = [...itemList];
  if (userAdded) {
    newUserList.push(userAdded);
  }
  if (userToBeDeleted) {
    const index = newUserList.findIndex((user) => user.id === userToBeDeleted.id);
    if (index > -1) {
      newUserList.splice(index, 1);
    }
  }
  return newUserList;
}

export default function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADING:
    case types.UPDATING_USER:
      return { ...state, isPageLoading: true };
    case types.LOADED:
    case types.TEAM_LIST_LOADING_START:
      return {
        ...state,
        teamViewListOptions: {
          items: [],
          isLoading: true,
        },
      };

    case types.LOADING_STATE_ACTIVE: {
      const items = _.get(state, 'usersAtFieldLevel.items', []);
      const selectedFieldList = _.get(state, 'usersAtFieldLevel.selectedFieldList', []);

      const { loadingState } = action;
      return {
        ...state,
        usersAtFieldLevel: {
          items,
          isLoading: loadingState,
          selectedFieldList,
        },
      };
    }
    case types.SET_GRID_PARAM: {
      return {
        ...state,
        gridParam: action.gridParam,
      };
    }
    case types.LOADING_STATE_INACTIVE: {
      const { loadingState } = action;

      const items = _.get(state, 'usersAtFieldLevel.items', []);
      const selectedFieldList = _.get(state, 'usersAtFieldLevel.selectedFieldList', []);

      return {
        ...state,
        usersAtFieldLevel: {
          items,
          isLoading: loadingState,
          selectedFieldList,
        },
      };
    }
    case types.SET_LOADER: {
      const { loader } = action;
      return {
        ...state,
        isLoading: loader,
      };
    }

    case types.EDIT_PAGE_LOADER_STATE: {
      const { loaderState } = action;
      return {
        ...state,
        userEditInfo: {
          isLoading: loaderState,
          user: state.userEditInfo.user,
          returnToPage: state.userEditInfo.returnToPage,
        },
      };
    }
    case types.LOADING_EDIT_USER: {
      return {
        ...state,
        userEditInfo: {
          isLoading: true,
          user: {},
          returnToPage: state.userEditInfo.returnToPage,
        },
      };
    }

    case types.EDIT_USER_LOAD_SUCCESS: {
      const { userEdit } = action;
      return {
        ...state,
        userEditInfo: {
          isLoading: state.userEditInfo.isLoading,
          user: userEdit || {},
          returnToPage: state.userEditInfo.returnToPage,
        },
      };
    }
    case types.EDIT_USER_LOAD_FAILED: {
      return {
        ...state,
        userEditInfo: {
          isLoading: false,
          user: {},
          returnToPage: {
            TaskViewPage: false,
            TaskEditPage: '',
          },
        },
      };
    }
    case types.RETURN_TASK_PAGE_STATE: {
      return {
        ...state,
        userEditInfo: {
          isLoading: false,
          user: state.userEditInfo.user,
          returnToPage: {
            TaskViewPage: true,
            TaskEditPage: '',
          },
        },
      };
    }
    case types.RETURN_TASK_EDIT_PAGE_STATE: {
      const { url } = action;
      return {
        ...state,
        userEditInfo: {
          isLoading: false,
          user: state.userEditInfo.user,
          returnToPage: {
            TaskViewPage: false,
            TaskEditPage: url,
          },
        },
      };
    }
    case types.REDIRECT_LINK_STATE_RESET: {
      return {
        ...state,
        userEditInfo: {
          isLoading: false,
          user: {},
          returnToPage: {
            TaskViewPage: false,
            TaskEditPage: '',
          },
        },
      };
    }

    case types.TEAM_LIST_LOADING_DONE: {
      const { teams } = action;
      return {
        ...state,
        teamViewListOptions: {
          items: teams,
          isLoading: false,
        },
      };
    }
    case types.TEAM_LIST_LOADING_STOP:
      return {
        ...state,
        teamViewListOptions: {
          items: [],
          isLoading: false,
        },
      };
    case types.AREA_LIST_LOADING_START:
      return {
        ...state,
        AreaViewListOptions: {
          items: [],
          isLoading: true,
        },
      };
    case types.AREA_LIST_LOADING_DONE: {
      const { areas } = action;
      return {
        ...state,
        AreaViewListOptions: {
          items: areas,
          isLoading: false,
        },
      };
    }
    case types.AREA_LIST_LOADING_STOP:
      return {
        ...state,
        AreaViewListOptions: {
          items: [],
          isLoading: false,
        },
      };
    case types.SET_USER_LIST:
      const { userList } = action;
      const usersList = _.get(userList, 'users', []);
      const presentUserList = _.get(state, 'usersAtFieldLevel.items', []);
      return {
        ...state,
        usersAtFieldLevel: {
          items: [...presentUserList, ...usersList],
          isLoading: false,
          selectedFieldList: _.get(state, 'usersAtFieldLevel.selectedFieldList', []),
        },
      };
    case types.SET_EXPORTING:
      const { isExporting } = action;
      return {
        ...state,
        isExporting,
      };
    case types.CREATE_USER_SUCCESS:
      return {
        ...state,
        usersAtFieldLevel: {
          items: addUser(state.usersAtFieldLevel.items, action.user, action.userToBeDeleted),
          isLoading: false,
          selectedFieldList: _.get(state, 'usersAtFieldLevel.selectedFieldList', []),
        },
        isPageLoading: false,
      };
    case types.UPDATE_USER_SUCCESS: {
      const updatedUserIds = (action?.users || []).map((val) => val.id);
      const userToBeDeletedIds = (action?.usersToBeDeleted || []).map((val) => val.id);
      const newUsers = state.usersAtFieldLevel.items.filter((item) => !userToBeDeletedIds.includes(item.id));
      return {
        ...state,
        usersAtFieldLevel: {
          items: [...newUsers.filter((item) => !updatedUserIds.includes(item.id)), ...(action?.users || [])],
          isLoading: false,
          selectedFieldList: state.usersAtFieldLevel.selectedFieldList,
        },
        isPageLoading: false,
      };
    }
    case types.USER_UPDATE_INFO: {
      const { users } = action;
      return {
        ...state,
        userInfoAfterEdit: {
          user: [...users],
          isLoading: false,
        },
        isPageLoading: false,
      };
    }

    case types.CLEAR_EDIT_USER_INFO: {
      return {
        ...state,
        userInfoAfterEdit: {
          user: [],
        },
      };
    }

    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        isPageLoading: false,
        usersAtFieldLevel: {
          items: deleteUser(state.usersAtFieldLevel.items, action.user),
          isLoading: false,
          selectedFieldList: state.usersAtFieldLevel.selectedFieldList,
        },
      };
    case types.UPDATE_USER_FAILED:
      const editUsersInfo = _.clone(state.userInfoAfterEdit.user);
      return {
        ...state,
        userInfoAfterEdit: {
          user: [...editUsersInfo],
          isLoading: false,
        },
        isPageLoading: false,
      };
    case types.LOADING_USERS_AT_FIELD_LEVEL: {
      return {
        ...state,
        usersAtFieldLevel: {
          items: [],
          isLoading: true,
        },
      };
    }
    case types.LOAD_USERS_AT_FIELD_LEVEL_SUCCESS: {
      const { users, selectedFieldList } = action;
      const allUsers = [..._.get(state, 'usersAtFieldLevel.items', []), ...(users || [])];
      return {
        ...state,
        usersAtFieldLevel: {
          items: allUsers,
          isLoading: false,
          selectedFieldList,
        },
        isPageLoading: false,
      };
    }

    case types.LOAD_USERS_AT_FIELD_LEVEL_FAILED: {
      return {
        ...state,
        usersAtFieldLevel: {
          items: [],
          isLoading: false,
        },
      };
    }
    case types.BULK_CREATE_USER_SUCCESS: {
      const { correctUsers, selectedFieldList } = action;
      const presentItems = state.usersAtFieldLevel.items || [];
      const updatedState = {
        ...state,
        usersAtFieldLevel: {
          items: [...presentItems, ...correctUsers],
          isLoading: false,
          selectedFieldList,
        },
      };
      return updatedState;
    }
    case types.BULK_CHECK_USER_SUCCESS: {
      const { correctUsers, incorrectUsers } = action;
      return {
        ...state,
        bulkUploadUsers: {
          correctUsers,
          incorrectUsers,
          isLoading: false,
        },
        isPageLoading: false,
      };
    }
    case types.BULK_CREATING_USER: {
      return {
        ...state,
        bulkUploadUsers: {
          isLoading: true,
        },
        isPageLoading: true,
      };
    }
    case types.BULK_CREATE_USER_FAILED: {
      return {
        ...state,
        bulkUploadUsers: {
          isLoading: false,
        },
        isPageLoading: false,
      };
    }
    case types.LOADING_VENDOR_PICKLIST: {
      return updatePickListsStateKey(state, 'vendorOptions', true, []);
    }
    case types.LOAD_VENDOR_PICKLIST_FAILED: {
      return updatePickListsStateKey(state, 'vendorOptions', false, []);
    }
    case types.LOAD_VENDOR_PICKLIST_SUCCESSFUL: {
      return updatePickListsStateKey(state, 'vendorOptions', false, action.pickListOptions);
    }
    case types.LOADING_CERTIFICATES_PICKLIST: {
      return updatePickListsStateKey(state, 'certificatesOptions', true, []);
    }
    case types.LOAD_CERTIFICATES_PICKLIST_FAILED: {
      return updatePickListsStateKey(state, 'certificatesOptions', false, []);
    }
    case types.LOAD_CERTIFICATES_PICKLIST_SUCCESSFUL: {
      return updatePickListsStateKey(state, 'certificatesOptions', false, action.pickListOptions);
    }
    case types.LOADING_SKILLLEVEL_PICKLIST: {
      return updatePickListsStateKey(state, 'skillLevelOptions', true, []);
    }
    case types.LOAD_SKILLLEVEL_PICKLIST_FAILED: {
      return updatePickListsStateKey(state, 'skillLevelOptions', false, []);
    }
    case types.LOAD_SKILLLEVEL_PICKLIST_SUCCESSFUL: {
      return updatePickListsStateKey(state, 'skillLevelOptions', false, action.pickListOptions);
    }
    case types.LOADING_ACLQUALIFIED_PICKLIST: {
      return updatePickListsStateKey(state, 'aclQualifiedOptions', true, []);
    }
    case types.LOAD_ACLQUALIFIED_PICKLIST_FAILED: {
      return updatePickListsStateKey(state, 'aclQualifiedOptions', false, []);
    }
    case types.LOAD_ACLQUALIFIED_PICKLIST_SUCCESSFUL: {
      return updatePickListsStateKey(state, 'aclQualifiedOptions', false, action.pickListOptions);
    }
    case types.LOAD_USERS_SUBSCRIPTION_SUCCESS: {
      const { updatedUser } = action;
      const users = state.usersAtFieldLevel.items.map((item) => item);
      const updatedItems = helper.userInsertOrUpdate(users, updatedUser);
      return {
        ...state,
        usersAtFieldLevel: {
          items: updatedItems,
        },
      };
    }
    default:
      return state;
  }
}
